// extracted by mini-css-extract-plugin
export default {"mergeCompanyAnnotetion":"MergeCompanyAnnotations_mergeCompanyAnnotetion__8WDGb"};